import { render, staticRenderFns } from "./previewSCCL.vue?vue&type=template&id=3b49ef0f&lang=html&"
import script from "./previewSCCL.vue?vue&type=script&lang=js&"
export * from "./previewSCCL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports